import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ContactExpertBigIcon extends BaseIcon {
  getChildren = () => {
    return [
      <g transform="translate(-1471.922 -186.934)">
        <g transform="translate(1472.422 195.365)">
          <circle cx="6.425" cy="6.425" r="6.425" transform="translate(1.606 0)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          <path d="M17.562,30.413V25.594a8.031,8.031,0,0,0-16.062,0v4.819H4.712L6.319,43.262h6.425l1.606-12.849Z" transform="translate(-1.5 -1.501)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        </g>
        <g transform="translate(1486.878 187.434)">
          <path d="M21.293,22.708H32.449l5.936,7.5.6-7.5h4.606A3.212,3.212,0,0,0,46.8,19.5V4.712A3.212,3.212,0,0,0,43.592,1.5H19.712A3.212,3.212,0,0,0,16.5,4.712" transform="translate(-16.5 -1.5)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          <path d="M6,5.65a3.151,3.151,0,1,1,4.2,2.971,1.575,1.575,0,0,0-1.05,1.486v.269" transform="translate(5.9 2.614)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
          <path d="M8.144,9.5a.394.394,0,1,0,.394.394A.394.394,0,0,0,8.144,9.5h0" transform="translate(6.907 6.641)" fill="none" stroke="#fff" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        </g>
      </g>
    ]
  }
  getViewBox = () => '0 0 45.76 50.691'
}
